import React from "react";

// Style
import "./style.css";

export default function NotFound() {
  return <div>Oops! That page can’t be found.</div>;
}
